<template>
	<div class="center_main">
		<el-row class="user_center_box">
			<el-col class="menuLeftParent" ref="menuLeft" :span="4">
				<div class="bg-purple menuLeft">
					<el-row class="user_tac">
						<el-col :span="24">
							<el-menu
								:default-active="currentTab"
								:active="currentTab"
								class="el-menu-vertical-demo"
								:unique-opened="true"
								text-color="#666666"
								active-text-color="#D86556"
								@open="handleOpen"
							>
								<el-submenu index="1">
									<template slot="title" index="1-1" style="height: 45px; line-height: 44px">
										<span
											:class="['iconfont', 'icon-gerenzhongxin-zhong1']"
											style="font-size: 18px; color: #a8b0ad"
										></span>
										<span class="titles">个人中心</span>
									</template>
									<el-menu-item-group>
										<el-menu-item @click="userAdministration('grsy')" index="1-1-1"> 个人首页 </el-menu-item>
										<el-menu-item @click="userAdministration('yhkgl')" index="1-1-2"> 银行卡管理 </el-menu-item>
										<el-menu-item @click="userAdministration('crypto')" index="1-1-5"> 虚拟/数字钱包 </el-menu-item>
										<el-menu-item @click="userAdministration('grzl')" index="1-1-3"> 个人资料 </el-menu-item>
										<el-menu-item @click="userAdministration('dljl')" index="1-1-4"> 登录记录 </el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="2">
									<template slot="title">
										<span :class="['iconfont', 'icon-caiwuzhongxin']" style="font-size: 20px; color: #a8b0ad"></span>
										<span class="titles">财务中心</span>
									</template>
									<el-menu-item-group>
										<el-menu-item @click="userAdministration('zhcz')" index="2-1-1"> 账户充值 </el-menu-item>
										<el-menu-item @click="userAdministration('yetx')" index="2-2-2"> 余额提现 </el-menu-item>
										<el-menu-item @click="userAdministration('zjzh')" index="2-3-3"> 资金转换 </el-menu-item>
										<el-menu-item @click="userAdministration('czjl')" index="2-4"> 充值记录 </el-menu-item>
										<el-menu-item @click="userAdministration('txjl')" index="2-5"> 提现记录 </el-menu-item>
										<el-menu-item @click="userAdministration('zzjl')" index="2-6"> 转账记录 </el-menu-item>
										<el-menu-item
											@click="userAdministration('Quick')"
											index="2-7"
											v-if="$store.state.quickWithdrawalState"
										>
											极速到帐
										</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="3">
									<template slot="title">
										<span :class="['iconfont', 'icon-dingdan']" style="font-size: 20px; color: #a8b0ad"></span>
										<span class="titles">订单报表</span>
									</template>
									<el-menu-item-group>
										<el-menu-item @click="userAdministration('tjbb')" index="3-0"> 统计报表 </el-menu-item>
										<el-menu-item @click="userAdministration('tzjl')" index="3-1"> 投注记录 </el-menu-item>
										<el-menu-item @click="userAdministration('zhjl')" index="3-2"> 追号记录 </el-menu-item>
										<el-menu-item @click="userAdministration('zbmx')" index="3-3"> 账变明细 </el-menu-item>
										<el-menu-item @click="userAdministration('jfmx')" index="3-4"> 积分明细 </el-menu-item>
										<el-menu-item @click="userAdministration('hdbb')" index="3-5"> 活动报表 </el-menu-item>
										<el-menu-item @click="userAdministration('sfjl')" index="3-7"> 三方记录 </el-menu-item>
									</el-menu-item-group>
								</el-submenu>
								<!-- <el-submenu index="5">
									<template slot="title">
										<span :class="['el-icon-chat-line-square']" style="font-size: 20px; color: #a8b0ad"></span>
										<span class="titles">消息中心</span>
									</template>
									<el-menu-item-group>
										<el-menu-item @click="userAdministration('sjx')" index="5-1">收件箱 </el-menu-item>
										<el-menu-item @click="userAdministration('fjx')" index="5-2">发件箱 </el-menu-item>
										<el-menu-item @click="userAdministration('fxx')" index="5-3">发消息 </el-menu-item>
									</el-menu-item-group>
								</el-submenu> -->
							</el-menu>
						</el-col>
					</el-row>
				</div>
			</el-col>
			<el-col class="menuRightParent" :span="20">
				<div class="panel_title">
					<span>{{ primaryName }}</span>
					<span class="el-icon-arrow-right"></span>
					<span style="color: #333">{{ panelName }}</span>
				</div>
				<div ref="menuRight" class="panel_content">
					<component :is="currentComponent" @routerChange="routerChange" />
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import grsy from "../UserComps/grsy";
import yhkgl from "../UserComps/yhkgl";
import crypto from "../UserComps/crypto";
import grzl from "../UserComps/grzl";
import dljl from "../UserComps/dljl";
import zhcz from "../AccountCenter/zhcz";
import yetx from "../AccountCenter/yetx";
import zjzh from "../AccountCenter/zjzh";
import czjl from "../AccountCenter/czjl";
import txjl from "../AccountCenter/txjl";
import zzjl from "../AccountCenter/zzjl";
import Quick from "../AccountCenter/Quick";
import tjbb from "../OrderReport/tjbb";
import tzjl from "../OrderReport/tzjl";
import zhjl from "../OrderReport/zhjl";
import zbmx from "../OrderReport/zbmx";
import jfmx from "../OrderReport/jfmx";
import hdbb from "../OrderReport/hdbb";
import yktj from "../OrderReport/yktj";
import sfjl from "../OrderReport/sfjl";
import sjx from "../InfoCenter/sjx";
import fjx from "../InfoCenter/fjx";
import fxx from "../InfoCenter/fxx";

export default {
	// 刷新页面
	inject: ["reload"],
	components: {
		grsy,
		yhkgl,
		crypto,
		grzl,
		dljl,
		zhcz,
		yetx,
		zjzh,
		czjl,
		txjl,
		zzjl,
		tzjl,
		zhjl,
		zbmx,
		jfmx,
		hdbb,
		yktj,
		sjx,
		fjx,
		fxx,
		tjbb,
		sfjl,
		Quick,
	},
	data() {
		return {
			panelInfo: {
				grsy: "个人首页",
				yhkgl: "银行卡管理",
				crypto: "虚拟/数字钱包",
				grzl: "个人资料",
				dljl: "登录记录",
				zhcz: "账户充值",
				yetx: "余额提现",
				zjzh: "资金转换",
				czjl: "充值记录",
				txjl: "提现记录",
				zzjl: "转账记录",
				tzjl: "投注记录",
				zhjl: "追号记录",
				zbmx: "账变明细",
				jfmx: "积分明细",
				hdbb: "活动报表",
				yktj: "盈亏统计",
				sjx: "收件箱",
				fjx: "发件箱",
				fxx: "发消息",
				tjbb: "统计报表",
				sfjl: "三方记录",
				Quick: "极速到帐",
			},
		};
	},
	computed: {
		currentComponent() {
			return this.$route.query.value;
		},
		primaryName() {
			if (this.currentTab.indexOf("1") === 0) return "个人中心";
			if (this.currentTab.indexOf("2") === 0) return "财务中心";
			if (this.currentTab.indexOf("3") === 0) return "订单报表";
			if (this.currentTab.indexOf("5") === 0) return "消息中心";

			const defaultPage = Object.keys(this.panelInfo)[0];

			this.$router.push({
				name: "UserCenter",
				query: {
					name: defaultPage,
					value: defaultPage,
				},
			});
		},
		panelName() {
			return this.panelInfo[this.$route.query.name];
		},
		currentTab() {
			switch (this.$route.query.value) {
				case "grsy":
					return "1-1-1";
				case "yhkgl":
					return "1-1-2";
				case "grzl":
					return "1-1-3";
				case "dljl":
					return "1-1-4";
				case "crypto":
					return "1-1-5";

				case "zhcz":
					return "2-1-1";
				case "yetx":
					return "2-2-2";
				case "zjzh":
					return "2-3-3";
				case "czjl":
					return "2-4";
				case "txjl":
					return "2-5";
				case "zzjl":
					return "2-6";
				case "Quick":
					return "2-7";

				case "tjbb":
					return "3-0";
				case "tzjl":
					return "3-1";
				case "zhjl":
					return "3-2";
				case "zbmx":
					return "3-3";
				case "jfmx":
					return "3-4";
				case "hdbb":
					return "3-5";
				case "yktj":
					return "3-6";
				case "sfjl":
					return "3-7";

				case "sjx":
					return "5-1";
				case "fjx":
					return "5-2";
				case "fxx":
					return "5-3";
				default:
					return "";
			}
		},
	},
	methods: {
		handleOpen(key) {
			switch (key) {
				case "1":
					this.userAdministration("grsy");
					break;
				case "2":
					this.userAdministration("zhcz");
					break;
				case "3":
					this.userAdministration("tjbb");
					break;
				case "5":
					this.userAdministration("sjx");
					break;
			}
		},
		userAdministration(val) {
			const inSameRoute = this.$route.query.name === val;
			if (inSameRoute) return;

			this.$router.push({
				name: "UserCenter",
				query: {
					name: val,
					value: val,
				},
			});
		},
		routerChange(value) {
			this.userAdministration(value);
		},
		fetchWithdrawalState() {
			try {
				this.$store.dispatch("getWithdrawalState").then(res => {
					if (!res.IsSucess) {
						this.$message.error(res.Message);
					}
				});
			} catch (e) {
				this.$message.error("网络异常，请刷新后再试");
			}
		},
	},
	created() {
		this.fetchWithdrawalState();
	},
};
</script>
<style lang="scss">
.unpaidState {
	color: #8b8b8b;
}

.chedan {
	color: #b0b0b0;
}

.cancelState {
	color: #008573;
}

.payState {
	color: #d86556;
}

/*给所有弹窗变头部*/

.el-table--border {
	border-left: 1px solid #ebeef5 !important;
}

.menuLeftParent .el-menu {
	border-right: none !important;
	background-color: #fcfcfc;
}

.menuLeftParent .el-submenu__title {
	padding-left: 30px !important;
	text-align: left;
	background-color: #f2f2f2;
	font-size: 16px;
	height: 50px;
	line-height: 50px;
}

.el-submenu__title:hover {
	background-color: #0e78c7 !important;
	color: white !important;
	.el-submenu__icon-arrow {
		color: #fff;
	}
}

.el-submenu__title:hover span {
	color: #ffffff !important;
}

.el-table--border th:last-child {
	border-right: 1px !important;
}

.tableData .el-table th:last-child {
	border-right: 1px !important;
}

.right_top {
	font-size: 18px !important;
	font-weight: bold !important;
}

.pay_succ {
	color: #4ada85;
}

.pay_fail {
	color: #818181;
}

/*此页面的样式*/
.center_main .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
	font-size: 16px;
}

.center_main .el-pager li {
	min-width: 32px !important;
}

.warning_img {
	margin: 0 0 10px;
	text-align: center;
}

/*重置左边导航栏选中颜色*/
.menuLeft .is-opened {
	border: none;
}

.menuLeft .is-opened > .el-submenu__title > span {
	margin-right: 10px;
	color: #000 !important;
}

.menuLeft .el-submenu {
	background: white;
	padding-bottom: 1px;
}

.menuLeftParent .el-menu-item {
	width: 100%;
	margin: 0 auto;
	color: #666;
	min-width: 100px !important;
}

.menuLeftParent .el-menu-item > span {
	display: inline-block;
	width: 8px;
	height: 8px;
	margin-right: 8px;
	border: solid 1px #a2a2a2;
	border-radius: 100%;
}

.menuLeftParent .el-menu-item:last-child {
	border: none;
}

.menuLeftParent .el-menu-item-group__title {
	display: none !important;
}

//右侧各种表格统一样式
.menuRightParent {
	.panel_content {
		.query_info {
			display: flex;
			flex-wrap: wrap;

			& > .el-input,
			& > .el-select {
				width: 220px;
				margin-right: 12px;
			}

			//输入框换行
			.input-br {
				width: 100%;
				height: 12px;
			}
		}

		.czTable {
			margin-top: 20px;
			overflow: hidden;
		}

		// 空列表的时候
		.table-empty {
			line-height: 1;
			padding: 30px;
			text-align: center;

			.table-empty-text {
				margin-top: 20px;
				font-size: 14px;
				color: #999;
			}
		}

		//分页器
		.my-paging {
			display: flex;
			justify-content: center;
			align-items: center;
			padding-top: 12px;
			font-size: 14px;

			.everyPageShow {
				color: #666;
			}

			.totalNum {
				margin-left: 15px;
				color: #333;
			}
		}

		/*彩票类型*/
		.lottery_type {
			border-bottom: 4px solid #e5e6eb;
			height: 48px;
			margin-bottom: 16px;
		}

		.lottery_type_item {
			height: 48px;
			width: 102px;
			float: left;
			font-size: 18px;
			text-align: center;
			line-height: 48px;
			// font-weight: 500;
			font-weight: 400;
		}

		.lottery_type_item_active {
			border-bottom: 4px solid #d86556;
		}
	}
}
</style>
<style lang="scss" scoped>
.center_main {
	padding: 20px 0;
}

.user_center_box {
	position: relative;
	background-color: #fff;
	width: 1200px;
	min-height: 660px;
	margin: auto;
	padding: 1px;

	.menuLeftParent {
		height: 100%;

		.menuLeft {
			.user_head {
				width: 100%;
				height: 140px;

				&::before {
					content: "";
					display: block;
					width: 195px;
					height: 3px;
					margin-left: -2px;
					background-color: #d86556;
					box-shadow: 0 1px 1px 0 rgba(49, 166, 157, 0.7);
				}

				div {
					width: 73px;
					height: 73px;
					margin: 21px auto 14px;
					background-color: #d86556;
					box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
					border-radius: 100%;

					img {
						width: 100%;
					}
				}

				p {
					font-size: 16px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 16px;
					letter-spacing: 0;
					color: #707070;
					text-align: center;
				}
			}
		}
	}

	.menuRightParent {
		min-height: 600px;
		background-color: #ffffff;
		.panel_title {
			display: flex;
			align-items: center;
			width: 100%;
			height: 50px;
			background-color: #f2f2f2;
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 1px;
			padding-left: 15px;
			color: #999;
		}

		.panel_content {
			width: 100%;
		}
	}
}

.bg-purple {
	background-color: #ffffff;
	padding-right: 15px;
}

/*左边导航、*/
.titles {
	color: #171717 !important;
}

.user_tac {
	text-align: center;
	color: white;
	overflow-x: hidden;
}

.top_nav {
	height: 50px;
	line-height: 50px;
	background-color: #74aca6;
}

.el-menu-vertical-demo {
	background-color: #ccdfe4;
}

.menuLeft li.el-menu-item {
	width: 100%;
	text-align: left;
	padding-left: 0px !important;
	padding-right: 10px !important;
	display: flex;
	justify-content: center;
	font-size: 16px;
}

.is-active {
	color: #6352fd !important;
}

.el-menu-item-group .is-active {
	border-right-color: #6352fd;
	border-right-width: 3px;
	border-right-style: solid;
}
</style>



// WEBPACK FOOTER //
// src/components/mainPage/UserCenter.vue